import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

import { resetPass } from "../../actions/userActions";
import { sessionCheck } from "../../apis/backend";
import history from "../../history";

import Form from "../CustomViews/Form";

const formName = "resetPassForm";
const ResetPassForm = reduxForm({ form: formName })(Form);

class ResetPass extends React.Component {
    constructor(props) {
        super(props);

        this.state = { render: false };
    }

    componentDidMount() {
        sessionCheck(true)
        .then(() => this.setState({ render: true }))
        .catch(() => {});
    }

    onSubmit = (formValues, onLoginError) => this.props.resetPass(formValues, () => history.push("/login"), error => onLoginError(error));

    render() {
        if (this.state.render) {
            return (
                <React.Fragment>
                    <div className="ui secondary pointing menu">
                        <div className="ui container">
                            <h3 className="item">Resetowanie hasła</h3>
                        </div>
                    </div>
                    <div className="ui container">
                        <ResetPassForm onSubmit={this.onSubmit} label="Resetuj" fields={[
                            { name: "email", type: "email", label: "Email:", placeholder:"Wpisz email...", autofocus: true }
                        ]} />
                    </div>
                </React.Fragment>
            );
        }
        else return null;
    }
}

export default connect(null, { resetPass })(ResetPass);